import React from 'react';
import ReactNativeStarRatingWidget from 'react-native-star-rating-widget';
import { IconStar } from './icons';
const EmmaStarIcon = React.memo(({ type, size, color }) => (<IconStar width={size} height={size} color={color} empty={type !== 'full'}/>));
/**
 * A wrapper around StarRating from `react-native-star-rating-widget`.
 *
 * Difference:
 * - the star icon is Emma's custom icon
 * - no half or quarter support
 */
const StarRating = ({ starSize = 44, ...props }) => (<ReactNativeStarRatingWidget StarIconComponent={EmmaStarIcon} step="full" starSize={starSize} {...props}/>);
export default React.memo(StarRating);
